import React, { useEffect, useState } from "react";
import CreditCardProp from "../components/CreditCardProp";
import { useNavigate, useParams } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import PageSEO from "../components/SEO_Component/PageSEO";
import BreadcrumbNav from "../components/BreadcrumbNav";

const CreditCardCategory = (props) => {
  const { lang, category } = useParams();
  const [data, setData] = useState({});
  const [allCards, setAllCards] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [section, setSection] = useState([]);

  const navigation = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API}${lang}/credit-cards-category/${category}?debug=true`
        );
        const data = await response.json();
        setData(data);

        if (data && data.sections) {
          const sectionsArray = [];
          for (const sectionKey in data.sections) {
            const section = data.sections[sectionKey];
            sectionsArray.push(section);
          }
          setSection(sectionsArray);
        }
        setIsLoading(false);

        window.scrollTo({
          top: 0,
          behavior: "instant",
        });
      } catch (err) {
        console.log(err.message);
        setIsLoading(false);
      }
    };
    fetchData();
  }, [lang, category]);

  return (
    <>
      {isLoading && (
        <div className="w-full flex items-center justify-center h-[80vh]">
          <CircularProgress />
        </div>
      )}

      {!isLoading && (
        <div className=" rounded-[10px] flex flex-col justify-center">
          <PageSEO seoData={data.seo} />
          <BreadcrumbNav pathSegments={[]} />
          <div className="flex justify-center mt-10 w-[90vw] text-center mx-auto mb-1">
            {isLoading ? (
              <div>Loading...</div>
            ) : (
              <h1 className="font-montserrat font-semibold text-[20px] md:text-[48px] md:mt-5 md:mb-5 leading-[24.38px] text-[#5C5A5A] mx-auto">
                {data.seo?.seo_title}
              </h1>
            )}
          </div>

          {/* Map through the section state and render headings */}

          {section.map((sectionObj, index) => (
            <div key={index}>
              {sectionObj.items && sectionObj.items.length > 0 && (
                <h2 className="mt-4 text-black text-base flex justify-center text-center font-montserrat font-semibold md:text-[25px] md:leading-[30.52px] md:my-6">
                  {sectionObj.heading}
                </h2>
              )}

              <div className="flex flex-col items-center mb-10">
                <div className="md:grid md:grid-cols-3 md:gap-4 md:mt-4 md:mb-4 md:mx-3">
                  <>
                    {sectionObj?.items?.map((item, index) => (
                      <div key={index}>
                        <div className="mt-8 md:mt-10" key={index}>
                          <CreditCardProp
                            title={item?.title ?? "Title"}
                            img={item?.image}
                            joining_fees={item?.joining_fees}
                            renewal_fees={item?.renewal_fees}
                            id={item?.id}
                            apply={item?.apply_link}
                            lang={lang}
                          />
                        </div>
                      </div>
                    ))}
                  </>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default CreditCardCategory;
